import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { LockKeyholeIcon, SparklesIcon } from 'lucide-react';
const VALID_NAMES = ['miguel', 'nohemi', 'nohemí'];
export function WelcomeScreen({
  onEnter
}: {
  onEnter: (name: string) => void;
}) {
  const [value, setValue] = useState('');
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    inputRef.current?.focus();
  }, []);
  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    const trimmed = value.trim().toLowerCase();
    if (VALID_NAMES.includes(trimmed)) {
      setError(false);
      setSuccess(true);
      setTimeout(() => onEnter(value.trim()), 800);
    } else {
      setError(true);
      setTimeout(() => setError(false), 1500);
    }
  }
  return <div className="min-h-screen w-full bg-gray-950 flex items-center justify-center relative overflow-hidden" data-id="element-2">
      {/* Subtle background glow */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-3">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-blue-500/5 rounded-full blur-3xl" data-id="element-4" />
      </div>

      <AnimatePresence mode="wait" data-id="element-5">
        {!success ? <motion.div key="form" initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="relative z-10 flex flex-col items-center gap-8 px-6" data-id="element-6">
            {/* Logo / Icon */}
            <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          delay: 0.2,
          type: 'spring',
          stiffness: 200
        }} className="w-16 h-16 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center" data-id="element-7">
              <LockKeyholeIcon size={28} className="text-white/60" data-id="element-8" />
            </motion.div>

            {/* Title */}
            <div className="text-center space-y-2" data-id="element-9">
              <h1 className="text-2xl font-bold text-white tracking-tight" data-id="element-10">
                God Digital System
              </h1>
              <p className="text-sm text-gray-500" data-id="element-11">
                Escribe tu nombre para acceder
              </p>
            </div>

            {/* Input */}
            <form onSubmit={handleSubmit} className="w-full max-w-xs flex flex-col items-center gap-4" data-id="element-12">
              <div className="relative w-full" data-id="element-13">
                <input ref={inputRef} type="text" value={value} onChange={e => {
              setValue(e.target.value);
              setError(false);
            }} placeholder="Tu nombre..." className={`w-full px-4 py-3 rounded-xl bg-white/5 border text-white text-center text-lg font-medium placeholder:text-gray-600 outline-none transition-all duration-300 ${error ? 'border-red-500/60 bg-red-500/5 shake' : 'border-white/10 focus:border-blue-500/50 focus:bg-white/[0.07]'}`} autoComplete="off" data-id="element-14" />
              </div>

              <AnimatePresence data-id="element-15">
                {error && <motion.p initial={{
              opacity: 0,
              y: -5
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0
            }} className="text-red-400 text-xs font-medium" data-id="element-16">
                    Acceso no autorizado
                  </motion.p>}
              </AnimatePresence>

              <motion.button type="submit" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full py-3 rounded-xl bg-white text-gray-950 font-semibold text-sm hover:bg-gray-100 transition-colors" data-id="element-17">
                Entrar
              </motion.button>
            </form>

            <p className="text-[11px] text-gray-700 mt-4" data-id="element-18">
              Solo acceso autorizado
            </p>
          </motion.div> : <motion.div key="success" initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.4
      }} className="relative z-10 flex flex-col items-center gap-4" data-id="element-19">
            <SparklesIcon size={32} className="text-blue-400" data-id="element-20" />
            <p className="text-white text-lg font-semibold" data-id="element-21">
              Bienvenido/a, {value.trim()}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}